import React from "react";
import Content from "components/Content";
import { useSelector } from "react-redux";
import { EuiBasicTable } from "@elastic/eui";
import { useAddQueryNavigation } from "helpers/hooks/url";

const CollectionList = () => {
  const collections = useSelector(state => state.filters.items);
  const addQuery = useAddQueryNavigation();

  const actions = [
    {
      name: "Löschen",
      description: "Diesen Filter löschen",
      icon: "trash",
      color: "danger",
      type: "icon",
      onClick: e => {
        addQuery("deleteFilter", e.id);
      }
    },
    {
      name: "Edit",
      isPrimary: true,
      description: "Diese Filter bearbeiten",
      icon: "pencil",
      type: "icon",

      onClick: e => {
        addQuery("editFilter", e.id);
      }
    }
  ];

  const columns = [
    { field: "id", name: "#" },
    { field: "label", name: "Label" },
    { field: "active", name: "Aktiv" },

    { field: "updated_at", name: "Letztes Update", dataType: "date" },
    { field: "created_at", name: "Erstellt am", dataType: "date" },

    { name: "Aktionen", actions }
  ];

  return (
    <Content title="Übersicht">
      <EuiBasicTable items={Object.values(collections)} columns={columns} />
    </Content>
  );
};
export default CollectionList;
